import { render, staticRenderFns } from "./ExhibitUpload.vue?vue&type=template&id=355bac4e&scoped=true&"
import script from "./ExhibitUpload.vue?vue&type=script&lang=js&"
export * from "./ExhibitUpload.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitUpload.vue?vue&type=style&index=0&id=355bac4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355bac4e",
  null
  
)

export default component.exports